import axios from 'axios';
import { DEFAULT_TIMEOUT, BASE_API_URL } from './axios';

export default class GraphQLClient {
  constructor(apiUrl, apiKey) {
    const config = {
      baseURL: BASE_API_URL,
      timeout: DEFAULT_TIMEOUT,
    };

    if (apiUrl) {
      config.baseURL = apiUrl;
    }

    if (apiKey) {
      config.headers = {
        common: {
          Authorization: apiKey,
        },
      };
    }

    this.axios = new axios.create(config);
  }

  async query(query, variables = {}) {
    const response = await this.axios.post('/graphql/', {
      query,
      variables,
    });

    if (response.data && response.data.errors) {
      throw new Error(response.data.errors[0].message);
    } else if (!response.data || !response.data.data) {
      return null;
    }

    return response.data.data;
  }
}